<template>
  <div id="grid-cajas">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>

      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Digite el código curso a buscar"
            single-line
            hide-details
            @keyup.enter.stop.prevent="loadData()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="itemsRegistro"
            :search="search"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
              <td class="text-xs-left">
                {{
                  props.item.establecimiento != null
                    ? props.item.establecimiento
                    : "-"
                }}
              </td>
              <td class="text-xs-left">{{ props.item.rbd }}</td>
              <td class="text-xs-left">{{ props.item.cajaContenedora }}</td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td class="text-xs-left">{{ props.item.fechaRecepcion }}</td>
            </template>
          </v-data-table>

          <!--  dsoto 10-11-2022 -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <!--  dsoto 10-11-2022 -->

          <!-- dsoto -->
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="totalPages"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          dark
          class="mb-2"
          @click="descarga()"
        >
          Descarga Masiva
          <v-icon right dark>folder</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-recepcion",
  components: {
    Loading,
    LoadingDescarga,
  },
  props: {
    tipeView: String,
    tipo_prueba: String,
    id_nivel: Number,
  },

  data() {
    return {
      search: "",
      page: 1,
      pages: 1,
      rowsPerPageItems: [20],
      totalPages: 0,
      dialogLoading: false,
      loading: false,
      itemsRegistro: [],
      headers: [
        { text: "Curso", align: "left", sortable: false, value: "codigoCurso" },
        {
          text: "Establecimiento",
          align: "left",
          sortable: false,
          value: "establecimiento",
        },
        { text: "Rbd", align: "left", sortable: false, value: "rbd" },
        { text: "Caja Contenedora", sortable: false, value: "cajaContenedora" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha Recepcion", sortable: false, value: "fechaRecepcion" },
      ],

      tabSelected: "",
      nivelSelect: "",
      nivelValue: "",
      rbdSelect: [],

      rbdValue: "",
      rbd: "",
      cantRegistros: 0,
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;

    this.loadData();
  },
  mounted() {},
  computed: {},
  watcher: {},

  methods: {
    async loadRegistrosFilter() {
      let id_nivel = parseInt(this.id_nivel);

      // dsoto 10-11-2022
      if (this.search.length > 0) {
        this.page = 1;
      }
      // dsoto 10-11-2022

      this.body = {
        idNivel: id_nivel && id_nivel != null ? id_nivel : null,
        codigoCurso: this.search,
        idContrato: this.$store.getters.contratoStored,
        tipoPrueba: this.tipo_prueba,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/capturaRecepcion/detailNivelTipoPrueba", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.cantRegistros = 0;
      this.page = 1;
      this.itemsRegistro = await this.loadRegistrosFilter();

      if (this.itemsRegistro.length > 0) {
        this.pages = this.itemsRegistro.length;

        this.cantRegistros = this.itemsRegistro[0].totalRegistros; // dsoto 10-11-2022
        this.totalPages = Math.ceil(this.pages / this.rowsPerPageItems); // dsoto 10-11-2022
      } else {
        this.page = 1;
        this.totalPages = 0;
        this.pages = 1;
      }
      this.loading = false;
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    async descarga() {
      this.dialogLoading = true;
      this.res = await this.downloadComplete();
      this.dialogLoading = false;
    },

    async downloadComplete() {
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Registro_Cajas.xlsx";
      let id_nivel = parseInt(this.id_nivel);
      this.body = {
        idNivel: id_nivel && id_nivel != null ? id_nivel : null,
        tipoPrueba:
          this.tipo_prueba && this.tipo_prueba != null
            ? this.tipo_prueba
            : null,
        idContrato: idContrato,
      };

      return await axios
        .post(
          "/capturaRecepcion/writeObjectToExcelCapturaRecepcionMasivo",
          this.body,
          { responseType: "blob" }
        )
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
